<template>
  <el-dialog
    title="Affiliate Model"
    :visible="dialog_model"
    width="500px"
    top="3vh"
    :modal="true"
    :append-to-body="true"
    @close="setDialogModel(false)"
  >
    <h5>Creator Affiliate Model</h5>
    <h4>Affiliate Partner Reward</h4>
    <p>AP YouTube Videos Reward (%)</p>
    <el-input-number
      v-model="affiliate_model.perc_model_percentage"
      clearable
    />
    <p>AP Fixed Reward ($)</p>
    <el-input-number
        v-model="affiliate_model.fixed_model_reward_user"
        clearable
    />
    <p>AP TikTok Videos Reward (%)</p>
    <el-input-number
        v-model="affiliate_model.perc_model_tiktok"
        clearable
    />
    <p>AP Instagram Videos Reward (%)</p>
    <el-input-number
        v-model="affiliate_model.perc_model_instagram"
        clearable
    />
    <p>AP Shorts Videos Reward (%)</p>
    <el-input-number
        v-model="affiliate_model.perc_model_shorts"
        clearable
    />
    <h4>Affiliate Customer Reward</h4>
    <p>AC Fixed Reward ($)</p>
    <el-input-number
      v-model="affiliate_model.reward_customer_vidcents"
      clearable
    />
    <p>AC and AP Reward TimeOut</p>
    <el-date-picker v-model="affiliate_model.perc_model_timeout_date" type="date" placeholder="Select period"
                    :value-format="'yyyy-MM-dd'" format="d MMMM yyyy">
    </el-date-picker>
    <h5>Artist & Label Affiliate Model</h5>
    <h4>Affiliate Partner Reward</h4>
    <p> AP Campaigns Reward (%) </p>
    <el-input-number v-model="affiliate_model.al_campaign_percentage" clearable/>
    <p> AP Reward TimeOut </p>
    <el-date-picker v-model="affiliate_model.al_valid_period" type="date" placeholder="Select period"
                    :value-format="'yyyy-MM-dd'" format="d MMMM yyyy">
    </el-date-picker>

    <h4>Affiliate Customer Reward</h4>
    <p> AC Fixed Reward ($) </p>
    <el-input-number v-model="affiliate_model.al_fixed_reward" clearable/>
    <p>AC Reward TimeOut</p>
    <el-date-picker v-model="affiliate_model.al_fixed_reward_period" type="date" placeholder="Select period"
                    :value-format="'yyyy-MM-dd'" format="d MMMM yyyy">
    </el-date-picker>

    <div slot="footer">
      <el-button
        type="primary"
        size="mini"
        @click="updateAffiliateModel()"
      >
        Save
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'

export default {
  computed: {
    ...mapState('affiliate', ['dialog_model', 'affiliate_model'])
  },

  methods: {
    ...mapActions('affiliate', ['updateAffiliateModel']),
    ...mapMutations('affiliate', ['setDialogModel'])
  }
}
</script>

<style scoped lang="scss">
h4, h5 {
  text-align: center;
}

h5 {
  font-size: 18px;
}
</style>